import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CrudType } from "@core/enums/crud-type";
import { ServiceHelper } from "@core/helpers/service-helper";
import { FiscalRegime } from "@core/models/fiscal-regime.model";
import { FundWithRelated } from "@core/models/fund-with-related.model";
import { Product, TProductsPaginated } from "@core/models/product.model";
import { ProductKind } from "@core/models/product-kind.model";
import { ProductVersions } from "@core/models/product-versions.model";
import { ProductsInfo } from "@core/models/products-info.model";
import { TPagination } from "@custom-types/sorting";
import { environment } from "@env/environment";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  constructor(private http: HttpClient) {}

  getProducts$(
    companyProducts?: boolean,
    activeVersions?: boolean,
    pagination?: Partial<TPagination> | undefined
  ): Observable<Array<Product> | TProductsPaginated> {
    let params = ServiceHelper.getListQueryParams(undefined, pagination);
    if (companyProducts) {
      params = params.append("companyProducts", companyProducts);
    }
    if (activeVersions) {
      params = params.append("activeVersions", activeVersions);
    }
    return this.http
      .get<Array<Product>>(`${environment.BASE_URL}product`, { params })
      .pipe(
        map(
          (
            response: Array<Product> | TProductsPaginated
          ): Array<Product> | TProductsPaginated => {
            return response;
          }
        )
      );
  }

  getFiscalRegime$(): Observable<Array<FiscalRegime>> {
    return this.http
      .get<Array<FiscalRegime>>(`${environment.BASE_URL}fiscalregime/`)
      .pipe(
        map((response: Array<FiscalRegime>): Array<FiscalRegime> => {
          return response;
        })
      );
  }

  getFunds$(): Observable<Array<FundWithRelated>> {
    return this.http
      .get<Array<FundWithRelated>>(`${environment.BASE_URL}fund/`)
      .pipe(
        map((response: Array<FundWithRelated>): Array<FundWithRelated> => {
          return response;
        })
      );
  }

  saveProduct$(
    product: Partial<Product>,
    id: string | undefined
  ): Observable<unknown> {
    const create = id === "";
    return this.http[create ? CrudType.Post : CrudType.Put](
      `${environment.BASE_URL}product/${!create ? `${id}` : ``}`,
      product
    );
  }

  saveProductVersion$(
    productVersion: Partial<ProductVersions>,
    id: string | undefined
  ): Observable<unknown> {
    const create = id === "";
    return this.http[create ? CrudType.Post : CrudType.Put](
      `${environment.BASE_URL}productversion/${!create ? `${id}` : ``}`,
      productVersion
    );
  }

  getProductsInfo$(): Observable<ProductsInfo> {
    return this.http
      .get<ProductsInfo>(`${environment.BASE_URL}product/info`)
      .pipe(
        map((response: ProductsInfo): ProductsInfo => {
          return response;
        })
      );
  }

  getProductKind$(): Observable<Array<ProductKind>> {
    return this.http
      .get<Array<ProductKind>>(`${environment.BASE_URL}product/kind`)
      .pipe(
        map((response: Array<ProductKind>): Array<ProductKind> => {
          return response;
        })
      );
  }

  getNonDeviatedCostsCount$(id: string): Observable<number> {
    return this.http
      .get<number>(
        `${environment.BASE_URL}productversion/${id}/gfhaccount/nondeviatedcostscount`
      )
      .pipe(
        map((response: number): number => {
          return response;
        })
      );
  }
}
